import { render, staticRenderFns } from "./RoomBookingManage.vue?vue&type=template&id=35f07f92"
import script from "./RoomBookingManage.vue?vue&type=script&lang=js"
export * from "./RoomBookingManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports